
const ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' + '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF';
const rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
const rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

/**
 * determines text align for rtl or ltr languages
 * @param text
 * @returns text align
 */
export function getTextAlign(value: string): string {
    return rtlDirCheck.test(value) ? 'right' : 'left';
}

/**
 * determines text direction for rtl or ltr languages
 * @param text
 * @returns text direction
 */
export function getTextDirection(value: string): string {
    return rtlDirCheck.test(value) ? 'rtl' : 'ltr';
}
